import { resolveAlwaysRequiredBack } from './back-requirement-always';
import { resolveConditionalBack } from './back-requirement-conditional';

export const BackRequirementMode = {
  ALWAYS: 'always',
  CONDITIONAL: 'conditional',
};

export const VerificationPhase = {
  FRONT_DISCOVERY: 'front_discovery',
  AWAITING_BOTH: 'awaiting_both',
  FRONT_ONLY: 'front_only',
};

export const getBackRequirementMode = backConditions =>
  backConditions && Object.keys(backConditions).length > 0
    ? BackRequirementMode.CONDITIONAL
    : BackRequirementMode.ALWAYS;

// Single call site for consumers — dispatches to whichever mode-specific module applies.
// `isBackRequired` only matters for CONDITIONAL mode (see back-requirement-conditional.js);
// evaluating it from the front's verify response isn't wired in yet, that's the next step.
export const resolveBackRequirement = (mode, isBackRequired) =>
  mode === BackRequirementMode.ALWAYS
    ? resolveAlwaysRequiredBack()
    : resolveConditionalBack(isBackRequired);
